import EmployeeIncome from "./EmployeeIncome";

export default EmployeeIncome;
